const styles = {
  root: {
    mt: 2,
  },
  inputGroup: {
    paddingBottom: 1,
  },
  contentController: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  inputLabel: {
    paddingBottom: 1,
    '&:not(:first-of-type)': {
      paddingTop: 2,
    },

  },

  field: {
    marginBottom: 2,
    'input:-internal-autofill-selected': {
      WebkitBoxShadow: '0 0 0 1000px white inset',
    },
    '& .MuiAutocomplete-inputRoot': {
      paddingY: '0px!important',
    },
    '& .MuiOutlinedInput-input': {
      paddingY: '12px!important',
      borderColor: '#343434!important',
    },
    '& ::-webkit-outer-spin-button': {
      display: 'none',
    },
    '& ::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& .MuiInputLabel-formControl': {
      fontSize: 12,
      color: (theme) => `${theme.palette.text.grey300}!important`,
    },
  },
  uploadIcon: {
    '&.MuiButtonBase-root': {
      p: 2,
      border: '1px solid #343434',
      borderRadius: '4px!important',
    },
  },

  nameFile: {
    width: '100%',
    p: 1.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #10B1D7',
    borderRadius: '4px',
    span: {
      cursor: 'pointer',
      fontSize: '16px!important',
    },
  },
  nameFileText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
  },

  finishLaterContent: { width: '100%', textAlign: 'center' },

  disclaimer: {
    backgroundColor: 'background.grey450',
    p: 1,
    textAlign: 'left',
    mx: 2,
    mt: 2,
  },

  contentBtns: {
    width: '100%',
    py: 2,
    display: 'flex',
    flexDirection: 'column',
  },

  btn: {
    padding: 1.5,
    marginTop: 2,
  },

  cancelBtn: { marginTop: 1, color: 'text.secondaryDark' },

  modal: {
    '& .MuiPaper-root': {
      borderRadius: 2,
    },
  },

  linklogin: {
    marginY: 1,
    textAlign: 'center',
  },
  linkText: {
    // paddingX: 3,
  },
  linksContainers: {
    justifyContent: 'center',
    mt: 2,
  },
}

export default styles
